export default "__VITE_ASSET__ts9bYVfU__"